<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler, imgPathFn } from '@/utils/common'

export default {
  name: 'Comp50',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler, imgPathFn,
    currentData(i) {
      let dataObj = {}
      this.moduleOption.list.forEach((item, idx) => {
        if (i === idx) dataObj = item
      })
      return dataObj
    }
  }
}
</script>

<template>
  <div class="modules-id-50">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-3 modules-id-50-content">
      <!-- v-for="(v, i) in moduleOption.list.slice(0, 7)" -->
      <div
        v-for="(v, i) in 6"
        :key="`modules-id-50-item-${v}`"
        class="item"
      >
        <el-image
          class="item-img"
          :class="`item-img-${v}`"
          :src="imgPathFn(currentData(i).photo)"
          alt="photo"
          fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-50-content {
  width: 378px;
  height: 398px;
  background: url('~imgs/modules/comp52-bg.webp') no-repeat center;
  background-size: 100% 100%;
  position: relative;
  .item {
    .item-img {
      width: 63px;
      height: 58px;
    }
    .item-img-1 {
      position: absolute;
      top: 97px;
      left: 79px;
      transform: rotate(-2deg);
    }
    .item-img-2 {
      position: absolute;
      top: 100px;
      left: 157px;
      transform: rotate(3deg);
    }
    .item-img-3 {
      position: absolute;
      top: 97px;
      left: 241px;
      transform: rotate(-9deg);
    }
    .item-img-4 {
      position: absolute;
      top: 218px;
      left: 79px;
      transform: rotate(-2deg);
    }
    .item-img-5 {
      position: absolute;
      top: 222px;
      left: 158px;
      transform: rotate(4deg);
    }
    .item-img-6 {
      position: absolute;
      top: 217px;
      left: 241px;
      transform: rotate(-8deg);
    }
  }
}
</style>
